import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Developers from '../components/Developers';

const DevelopersPage = () => {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      style={{ background: '#1E1E1E', minHeight: '100vh', position: 'relative' }}
    >
      <button
        onClick={() => navigate(-1)}
        style={{
          position: 'absolute',
          top: 20,
          left: 20,
          background: 'none',
          border: 'none',
          color: 'white',
          fontSize: '2rem',
          cursor: 'pointer',
          zIndex: 10
        }}
        aria-label="Go Back"
      >
        &#8592;
      </button>
      <Developers />
    </motion.div>
  );
};

export default DevelopersPage;
